import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { FiltersSelect } from './filters-select';
import { DownArrowIcon, UpArrowIcon } from './icons';
var Container = styled.div({
    display: 'flex',
    flexWrap: 'wrap',
});
var Item = styled.div({
    '&:not(:first-child)': {
        marginLeft: '15px',
    },
});
export var FiltersRow = function (_a) {
    var filters = _a.filters, value = _a.value, onChange = _a.onChange, className = _a.className;
    var _b = useState(), visibleFilterId = _b[0], setVisibleFilterId = _b[1];
    var showFilter = useCallback(function (filterId) {
        setVisibleFilterId(filterId);
    }, []);
    var hideFilter = useCallback(function () {
        setVisibleFilterId(undefined);
    }, []);
    return (_jsx(Container, { children: filters.map(function (filter) {
            var isOpen = filter.id === visibleFilterId;
            return (_jsx(Item, { children: _jsx(FiltersSelect, { filter: filter, value: value, onChange: onChange, isOpen: isOpen, onShow: showFilter, onHide: hideFilter, Icon: isOpen ? _jsx(UpArrowIcon, {}, void 0) : _jsx(DownArrowIcon, {}, void 0), className: className }, void 0) }, filter.id));
        }) }, void 0));
};
